var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAventura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 39,
    viewBox: "0 0 48 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4493 0C20.8959 0 20.4507 0.4452 20.4507 0.998598V38.0014C20.4507 38.5506 20.8959 39 21.4493 39H25.5686C26.122 39 26.5672 38.5548 26.5672 38.0014V0.998598C26.5672 0.4452 26.122 0 25.5686 0H21.4493ZM24.57 37.0028H22.4479V1.99722H24.57V37.0028Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1981 22.577L46.6933 19.4813C46.9055 19.2941 47.0303 19.0194 47.0303 18.7323C47.0303 18.4452 46.9097 18.1748 46.6933 17.9834L43.1981 14.8877C43.0151 14.7254 42.7821 14.638 42.5366 14.638H28.5601C28.0067 14.638 27.5615 15.0832 27.5615 15.6366V21.8239C27.5615 22.3731 28.0067 22.8225 28.5601 22.8225H42.5366C42.7821 22.8225 43.0151 22.7351 43.1981 22.5728V22.577ZM29.5588 16.6394H42.1579L44.5255 18.7365L42.1579 20.8336H29.5588V16.6394Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5645 4.52708C28.0111 4.52708 27.5659 4.97228 27.5659 5.52568V11.7129C27.5659 12.2663 28.0111 12.7115 28.5645 12.7115H42.541C42.7864 12.7115 43.0195 12.6242 43.2025 12.4619L46.6977 9.3662C46.9099 9.17896 47.0347 8.90432 47.0347 8.61722C47.0347 8.33012 46.914 8.05966 46.6977 7.86826L43.2025 4.77256C43.0195 4.61029 42.7864 4.52292 42.541 4.52292H28.5645V4.52708ZM29.5631 10.7143V6.52014H42.1623L44.5299 8.61722L42.1623 10.7143H29.5631Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82802 12.4577C4.0111 12.62 4.24827 12.7074 4.4896 12.7074H18.466C19.0194 12.7074 19.4646 12.2622 19.4646 11.7088V5.52152C19.4646 4.96812 19.0194 4.52292 18.466 4.52292H4.49376C4.24827 4.52292 4.01526 4.61029 3.83218 4.77256L0.337032 7.86826C0.124827 8.0555 0 8.33012 0 8.61722C0 8.90432 0.120666 9.1748 0.337032 9.3662L3.83218 12.4619L3.82802 12.4577ZM17.4674 6.52014V10.7143H4.8724L2.50485 8.61722L4.8724 6.52014H17.4716H17.4674Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAventura);
export default __webpack_public_path__ + "static/media/ic_aventura.8285043666b573fe8b9f909961d7b9d8.svg";
export { ForwardRef as ReactComponent };